import { render, staticRenderFns } from "./linkDetails.vue?vue&type=template&id=27153a4e"
import script from "./linkDetails.vue?vue&type=script&lang=js"
export * from "./linkDetails.vue?vue&type=script&lang=js"
import style0 from "./linkDetails.vue?vue&type=style&index=0&id=27153a4e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports